import { render, staticRenderFns } from "./chinaPostProductConfiguration.vue?vue&type=template&id=0c68db58&scoped=true&"
import script from "./chinaPostProductConfiguration.vue?vue&type=script&lang=js&"
export * from "./chinaPostProductConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./chinaPostProductConfiguration.vue?vue&type=style&index=0&id=0c68db58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c68db58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c68db58')) {
      api.createRecord('0c68db58', component.options)
    } else {
      api.reload('0c68db58', component.options)
    }
    module.hot.accept("./chinaPostProductConfiguration.vue?vue&type=template&id=0c68db58&scoped=true&", function () {
      api.rerender('0c68db58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/chinaPostProductConfiguration/chinaPostProductConfiguration.vue"
export default component.exports